<script lang="ts">import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const RecentlyTabIcon = getIcon("RecentlyTabIcon");
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof RecentlyTabIcon === 'string'}
	<img src={RecentlyTabIcon} alt={$t(Verbiage.recently_tab_icon_alt, 'alts')} />
{:else if typeof RecentlyTabIcon === 'function'}
	<svelte:component this={RecentlyTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
